import React, { useState } from "react";

const Carousel = ({ images }: { images: string[] }) => {
  const [current, setCurrent] = useState(0);
  const length = images.length;

  // 次のスライドへ
  const nextSlide = () => {
    setCurrent(current === length - 1 ? 0 : current + 1);
  };

  // 前のスライドへ
  const prevSlide = () => {
    setCurrent(current === 0 ? length - 1 : current - 1);
  };

  return (
    <div className="tw-relative tw-w-full tw-max-w-3xl tw-mx-auto tw-mb-4">
      {/* スライドコンテナ */}
      <div className="tw-relative tw-overflow-hidden tw-h-24 tw-w-24 tw-mx-auto">
        {images.map((image, index) => (
          <div
            key={index}
            className={`tw-absolute tw-inset-0 tw-transition-opacity tw-duration-500 ${
              index === current ? "tw-opacity-100" : "tw-opacity-0"
            }`}
          >
            <div className="tw-w-full tw-h-full tw-relative tw-overflow-hidden tw-rounded-lg">
              <img
                src={image}
                alt={`Slide ${index}`}
                className="tw-w-full tw-h-full tw-object-cover"
              />
            </div>
          </div>
        ))}
      </div>

      {/* 前へボタン */}
      {images.length > 1 && (
        <button
          onClick={prevSlide}
          className="tw-absolute tw-left-4 tw-top-1/2 tw-transform tw--translate-y-1/2 tw-bg-white tw-bg-opacity-50 tw-text-gray-800 tw-p-2 tw-rounded-full tw-hover:bg-gray-600 tw-cursor-pointer"
        >
          Prev
        </button>
      )}

      {/* 次へボタン */}
      {images.length > 1 && (
        <button
          onClick={nextSlide}
          className="tw-absolute tw-right-4 tw-top-1/2 tw-transform tw--translate-y-1/2 tw-bg-white tw-bg-opacity-50 tw-text-gray-800 tw-p-2 tw-rounded-full tw-hover:bg-gray-600 tw-cursor-pointer"
        >
          Next
        </button>
      )}
    </div>
  );
};

export default Carousel;
